import { render, staticRenderFns } from "./place-on-file-modal.vue?vue&type=template&id=bb6311ca&scoped=true&"
import script from "./place-on-file-modal.vue?vue&type=script&lang=js&"
export * from "./place-on-file-modal.vue?vue&type=script&lang=js&"
import style0 from "./place-on-file-modal.vue?vue&type=style&index=0&id=bb6311ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6311ca",
  null
  
)

export default component.exports